const viewMore = document.getElementById('link');
const btn = document.querySelector('.view-more-images');
const galleries = document.querySelectorAll('.--extended');

if(viewMore) {
    viewMore.addEventListener('click', () => { 
        btn.classList.add('--extended');
        [...galleries].forEach((gallery) => {
            gallery.classList.remove('--extended');
        });
    });    
}
